import { useEffect } from 'react';

export default function SeoHead({
  title,
  description,
  canonicalPath,
  faqs = [],
  datePublished = '2026-10-01',
  dateModified = '2026-10-01',
}) {
  useEffect(() => {
    // Sidetitel under 60 tegn
    document.title = title;

    // Meta description under 160 tegn
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.name = 'description';
      document.head.appendChild(metaDesc);
    }
    metaDesc.content = description;

    // Canonical link
    const canonicalUrl = `https://www.radiatorproblemer.dk${canonicalPath}`;
    let linkCanonical = document.querySelector('link[rel="canonical"]');
    if (!linkCanonical) {
      linkCanonical = document.createElement('link');
      linkCanonical.rel = 'canonical';
      document.head.appendChild(linkCanonical);
    }
    linkCanonical.href = canonicalUrl;

    // JSON-LD scripts
    const scriptId = 'page-jsonld-schema';
    let scriptTag = document.getElementById(scriptId);
    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }

    const schemas = [];

    if (canonicalPath === '/' || canonicalPath === '') {
      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'WebSite',
        name: 'Radiatorproblemer.dk',
        url: 'https://www.radiatorproblemer.dk/',
        inLanguage: 'da',
      });
    } else {
      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'Article',
        headline: title,
        description: description,
        url: canonicalUrl,
        inLanguage: 'da',
        datePublished: datePublished,
        dateModified: dateModified,
        publisher: {
          '@type': 'Organization',
          name: 'Radiatorproblemer.dk',
          url: 'https://www.radiatorproblemer.dk/',
        },
      });

      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: 'Forside',
            item: 'https://www.radiatorproblemer.dk/',
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: title,
            item: canonicalUrl,
          },
        ],
      });
    }

    if (faqs && faqs.length > 0) {
      schemas.push({
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: faqs.map((f) => ({
          '@type': 'Question',
          name: f.q,
          acceptedAnswer: {
            '@type': 'Answer',
            text: f.a,
          },
        })),
      });
    }

    scriptTag.text = JSON.stringify(schemas);

    // Scroll til toppen ved sideskift
    window.scrollTo(0, 0);

    return () => {
      // Ryd script op hvis relevant
    };
  }, [title, description, canonicalPath, faqs, datePublished, dateModified]);

  return null;
}
